import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fdf8e4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widthRole meetingReg" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "参会注册", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, " 会议费用 ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  border: "1",
  cellspacing: "0"
}, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "会议注册费"),
    /*#__PURE__*/_createElementVNode("td", null, "非会员"),
    /*#__PURE__*/_createElementVNode("td", null, "普通会员"),
    /*#__PURE__*/_createElementVNode("td", null, "学生会员")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "无论文参会者"),
    /*#__PURE__*/_createElementVNode("td", null, "2200 "),
    /*#__PURE__*/_createElementVNode("td", null, "1800"),
    /*#__PURE__*/_createElementVNode("td", null, "800")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "有1篇论文的参会者"),
    /*#__PURE__*/_createElementVNode("td", null, " 2600 "),
    /*#__PURE__*/_createElementVNode("td", null, "2200"),
    /*#__PURE__*/_createElementVNode("td", null, "1200")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "有2篇论文的参会者"),
    /*#__PURE__*/_createElementVNode("td", null, "2800"),
    /*#__PURE__*/_createElementVNode("td", null, "2400"),
    /*#__PURE__*/_createElementVNode("td", null, "1400")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "注册方式", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "1、注册通道", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请点击以下链接或扫描二维码注册报名：", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("注册链接："),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.cacpaper.com/register/913/user/preRegist",
    target: "_blank"
  }, "https://www.cacpaper.com/register/913/user/preRegist")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注册二维码:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "2、参会类型", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "参会类型可选择为“中国自动化学会会员”需要填写中国自动化 学会会员编号；参会类型选择为“学生+中国自动化学会会员”需要 填写中国自动化学会会员编号，并上传学生证照片。以邮箱或手机号 作为用户名登陆中国自动化学会会员系统：http://member.caa.org.cn/，即可查看会员编号。", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "3、参会人信息", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 选择已有参会人信息（往年参会时填写的个人信息）或新增参会人信息，新增完成后选中即可。 ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "4、论文列表 Paper List（无论文作者跳过此步）", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 论文作者在注册时务必添加论文，否则将影响最终的论文收录， 论文可使用论文 ID 搜索添加，如为通过投稿系统跳转到注册系统， 系统会自动选择账号下的论文。 ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "underline" }, " 每位注册者最多可提交有其署名的论文两篇，由于系统有同一用 户重复注册限制，如超过两篇需要论文合作者重新进行注册流程。 ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "underline" }, " 每篇论文一般限 6 页，如超过 6 页，每超 1 页加收 800 元超页费；每篇论文最多不超过8页。 ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "5、支付方式", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "支付方式可选择为银行转账，支付宝，微信，银联在线及现场支付。", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "银行转账：", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 选择银行转账后，系统将提示您转账的相关信息，转账时请 务必备注“NIVDF+PaperID+姓名”，如无论文参会请备注“NIVDF+ 姓名”，银行转账完成后需重新登陆到系统上传转账凭证，银行 转账的记录需要财务确认后，方可变更为已缴费状态。 转账凭证请保留转账户名，转账时间，转账金额及备注信息。 支付宝/微信支付/银联在线： ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 填写完发票信息提交后，在跳转页面点击“付款”按钮，按 照提示完成在线支付即可。 ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 现场支付： ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 选择现场支付注册完成后，于会议现场缴纳注册费。 ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "6、发票信息", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 发票统一开具“会议注册费”，原则上均为增值税电子普通发票。 ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 如需开具发票，发票抬头及纳税人识别号为必填项，发票地址及 电话、发票开户行及账号两个信息为单位财务发票信息，如无强制要 求可不填。 ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 发票需在学会财务确认后推送到注册电子邮箱，同时可登陆注册 系统查看下载电子发票，缴费完成到开具发票有时间差，还请耐心等 待。 ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "7、保存签到卡", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 系统自动生成签到卡，请下载妥善保存，会议现场签到时出示签 到卡即可快速完成签到！ ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "8、编辑注册信息", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 登陆系统点击“编辑”按钮，可修改个人信息，如已经确认缴费 则无法修改“参会类型”及“论文列表 Paper List”，请于缴费前 确认相关信息。 ", -1))

import leftMenu from '@/components/LeftMenu.vue';
import shortNav from '@/components/shortNav.vue';
// import reg6 from '@/assets/img/reg6.png'
// import reg5 from '@/assets/img/reg5.png'
// import reg4 from '@/assets/img/reg4.png'
// import reg3 from '@/assets/img/reg3.png'
// import reg2 from '@/assets/img/reg2.png'
// import reg1 from '@/assets/img/reg1.png'
// import qrpng from '@/assets/img/qr.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'meetingRegist',
  setup(__props) {

const reg1 = 'https://caa-upload.cacpaper.com/nivdf2023/reg1.png'
const reg2 = 'https://caa-upload.cacpaper.com/nivdf2023/reg2.png'
const reg3 = 'https://caa-upload.cacpaper.com/nivdf2023/reg3.png'
const reg4 = 'https://caa-upload.cacpaper.com/nivdf2023/reg4.png'
const reg5 = 'https://caa-upload.cacpaper.com/nivdf2023/reg5.png'
const reg6 = 'https://caa-upload.cacpaper.com/nivdf2023/reg6.png'
const qrpng = 'https://caa-upload.cacpaper.com/nivdf2023/qr.png'



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(leftMenu),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(shortNav, null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", { class: "art" }, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", null, [
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: qrpng,
              alt: ""
            })
          ]),
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("img", {
            src: reg1,
            alt: ""
          }),
          _hoisted_15,
          _hoisted_16,
          _hoisted_17,
          _hoisted_18,
          _createElementVNode("img", {
            src: reg2,
            alt: ""
          }),
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("img", {
            src: reg3,
            alt: ""
          }),
          _hoisted_21,
          _hoisted_22,
          _hoisted_23,
          _createElementVNode("img", {
            src: reg4,
            alt: ""
          }),
          _hoisted_24,
          _hoisted_25,
          _hoisted_26,
          _hoisted_27,
          _hoisted_28,
          _hoisted_29,
          _createElementVNode("img", {
            src: reg5,
            alt: ""
          }),
          _hoisted_30,
          _hoisted_31,
          _hoisted_32,
          _hoisted_33,
          _createElementVNode("img", {
            src: reg6,
            alt: ""
          })
        ])
      ])
    ])
  ]))
}
}

})